import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ODBService } from './odb.service';
import { SNItemFactory } from '../models/snitemfactory';

@Injectable({
  providedIn: 'root'
})
export class BecareService {

  private static instance: BecareService = null;

  public url = '';
  public callurl = '';
  public wsurl = '';
  public bearer = '';
  public cookies: any;

  public authenticated = false;
  public userid = -1;
  private phpcookie: string;

  protected authStatusSource: BehaviorSubject<boolean | null>;

  constructor(private http: HttpClient, private odb: ODBService, private factory: SNItemFactory) {
    this.authStatusSource = new BehaviorSubject(null);
    this.url = window.location.protocol + '//' + window.location.host;
    this.wsurl = window.location.host;
    this.callurl = this.url + '/api/v1';
    BecareService.instance = this;
  }

  public static getInstance(): BecareService {
    return BecareService.instance;
  }

  public authStatus(): Observable<boolean | null> {
    return this.authStatusSource.asObservable();
  }

  private cleanAuth() {
    this.authenticated = false;
    this.userid = -1;
    localStorage.removeItem('becare-logged-userid');
    localStorage.removeItem('becare-logged-bearer');
  }

  public authenticate(login: string, password: string): Observable<boolean> {
    return new Observable(observer => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json'
        }),
        withCredentials: true
      };
      const body = {
        username: login,
        password
      };
      const authurl = this.callurl + '/authenticate';
      this.http.post<any>(authurl, body, httpOptions).subscribe(result => {
        console.log(result);
        console.log(result.header);
        if (typeof(result.success) === 'undefined') {
          this.authStatusSource.next(false);
          observer.next(false);
        } else {
          if (result.success === false) {
            // emit event to notify failed authentication
            this.authStatusSource.next(false);
            observer.next(false);
          } else {
            if (typeof(result.auth) === 'undefined') {
              this.authStatusSource.next(false);
              observer.next(false);
            } else {
              this.bearer = result.auth.bearer;
              this.odb.connBearer = this.bearer;
              this.authenticated = true;
              this.userid = result.auth.userid;
              localStorage.setItem('becare-logged-remote_addr', result.auth.remote_addr);
              localStorage.setItem('becare-logged-userid', result.auth.userid);
              localStorage.setItem('becare-logged-bearer', result.auth.bearer);
              this.authStatusSource.next(true);
              observer.next(true);
            }
          }
        }
      }, error => {
        this.authStatusSource.next(false);
        observer.next(false);
      });
    });
  }

  public autoAuthenticate(): Observable<boolean> {
    return new Observable(observer => {
      if (localStorage.getItem('becare-logged-userid') && localStorage.getItem('becare-logged-bearer')) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type':  'application/json'
          }),
          withCredentials: true
        };
        const body = {
          bearer: localStorage.getItem('becare-logged-bearer')
        };
        const authurl = this.callurl + '/authenticate';
        this.http.post<any>(authurl, body, httpOptions).subscribe(result => {
          console.log('authenticate bearer result ', result);
          if (result.success === false) {
            this.unAuthenticate();
            observer.next(false);
          } else {
            this.authenticated = true;
            this.userid = parseInt(localStorage.getItem('becare-logged-userid'), 10);
            this.bearer = localStorage.getItem('becare-logged-bearer');
            this.odb.connBearer = this.bearer;
            this.authStatusSource.next(true);
            observer.next(true);
          }
        });
      } else {
        observer.error('No user pre authenticated');
        this.authenticated = false;
        this.authStatusSource.next(false);
      }
    });
  }

  public checkAuthentication() {
    if (!localStorage.getItem('becare-logged-userid')) {
      return false;
    }
    return this.authenticated;
  }

  public unAuthenticate() {
    localStorage.removeItem('becare-logged-remote_addr');
    localStorage.removeItem('becare-logged-userid');
    localStorage.removeItem('becare-logged-bearer');
    this.userid = -1;
    this.authenticated = false;
    this.call('/authenticate/logoff').subscribe(result => {
      this.authStatusSource.next(false);
    });
  }

  /******************** HELPERS *********************/

  /**
   *
   * @param rest the rest call
   * @param queryvalues URI query params
   * @param body The call body
   * @param method The method used : get,post,put,delete
   * @param resultkey The keys used to return values as array
   */
  call(rest: string, queryvalues: [string, string][] = [], body: string | object = '',
       method: string = 'get', resultkey: string = '', isItem = false): Observable<any> {
    return new Observable(observer => {
      let urltocall = this.callurl + rest;
      if (queryvalues.length !== 0) {
        const urlparams = [];
        queryvalues.forEach(valuepair => {
          urlparams.push(valuepair.join('='));
        });
        urltocall += '?' + encodeURI(urlparams.join('&'));
      }
      switch (method) {
        case 'post':
          {
            let httpOptions;
            if (body.toString().indexOf('[object FormData]') === 0) {
              httpOptions = {
                headers: new HttpHeaders({
                  Authorization: 'Bearer ' + this.bearer
                }),
                withCredentials: true
              };
            } else {
              httpOptions = {
                headers: new HttpHeaders({
                  'Content-Type':  'application/json',
                  Authorization: 'Bearer ' + this.bearer
                }),
                withCredentials: true
              };
            }
            this.http.post(urltocall, body, httpOptions).subscribe(results => {
              try {
                if (resultkey.length !== 0) {
                  if (typeof results[resultkey] === 'undefined') {
                    // No result key found
                    console.log('No result key found ', results);
                    observer.error('No result key found');
                  } else {
                    results = results[resultkey];
                  }
                }
                if (isItem) {
                  if (results instanceof Array) {
                    const buildItems = this.factory.itemsFromJson(results);
                    if (buildItems === null || buildItems.length === 0) {
                      observer.next(results);
                    } else {
                      observer.next(buildItems);
                    }
                  } else {
                    const buildItem = this.factory.itemFromJson(results);
                    if (buildItem === null) {
                      observer.next(results);
                    } else {
                      observer.next(buildItem);
                    }
                  }
                } else {
                  observer.next(results);
                }
              } catch (exception) {
                // Just return json
                console.log('Exception ' + exception.message + ' during call to ', urltocall);
                observer.error('Exception during call to');
              }
            }, error => {
              if (error.status === 403) {
                // Forbidden access
                localStorage.removeItem('becare-logged-remote_addr');
                localStorage.removeItem('becare-logged-userid');
                localStorage.removeItem('becare-logged-bearer');
                this.authenticated = false;
                this.authStatusSource.next(false);
              }
              observer.error(error);
            });
          }
          break;
        case 'put':
          {
          const httpOptions = {
            headers: new HttpHeaders({
              'Content-Type':  'application/json',
              Authorization: 'Bearer ' + this.bearer
            }),
            withCredentials: true
          };
          this.http.put(urltocall, body, httpOptions).subscribe(results => {
            try {
              if (resultkey.length !== 0) {
                if (typeof results[resultkey] === 'undefined') {
                  // No result key found
                  console.log('No result key found ', results);
                  observer.error('No result key found');
                } else {
                  results = results[resultkey];
                }
              }
              if (isItem) {
                if (results instanceof Array) {
                  const buildItems = this.factory.itemsFromJson(results);
                  if (buildItems === null || buildItems.length === 0) {
                    observer.next(results);
                  } else {
                    observer.next(buildItems);
                  }
                } else {
                  const buildItem = this.factory.itemFromJson(results);
                  if (buildItem === null) {
                    observer.next(results);
                  } else {
                    observer.next(buildItem);
                  }
                }
              } else {
                observer.next(results);
              }
            } catch (exception) {
              // Just return json
              console.log('Exception ' + exception.message + ' during call to ', urltocall);
              observer.error('Exception during call to');
            }
          }, error => {
            if (error.status === 403) {
              // Forbidden access
              localStorage.removeItem('becare-logged-remote_addr');
              localStorage.removeItem('becare-logged-userid');
              localStorage.removeItem('becare-logged-bearer');
              this.authenticated = false;
              this.authStatusSource.next(false);
            }
            observer.error(error);
          });
          }
          break;
        case 'get':
          {
            try {
              const httpOptions = {
                headers: new HttpHeaders({
                  'Content-Type':  'application/json',
                  Authorization: 'Bearer ' + this.bearer
                }),
                withCredentials: true
              };
              this.http.get(urltocall, httpOptions).subscribe(results => {
                try {
                  if (resultkey.length !== 0) {
                    if (typeof results[resultkey] === 'undefined') {
                      // No result key found
                      console.log('No result key found ', results);
                      observer.error('No result key found');
                    } else {
                      results = results[resultkey];
                    }
                  }
                  if (isItem) {
                    if (results instanceof Array) {
                      const buildItems = this.factory.itemsFromJson(results);
                      if (buildItems === null || buildItems.length === 0) {
                        observer.next(results);
                      } else {
                        observer.next(buildItems);
                      }
                    } else {
                      const buildItem = this.factory.itemFromJson(results);
                      if (buildItem === null) {
                        observer.next(results);
                      } else {
                        observer.next(buildItem);
                      }
                    }
                  } else {
                    observer.next(results);
                  }
                } catch (exception) {
                  // Just return json
                  console.log('Exception ' + exception.message + ' during call to ', urltocall);
                  observer.error('Exception during call to');
                }
              }, error => {
                if (error.status === 403) {
                  // Forbidden access
                  localStorage.removeItem('becare-logged-remote_addr');
                  localStorage.removeItem('becare-logged-userid');
                  localStorage.removeItem('becare-logged-bearer');
                  this.authenticated = false;
                  this.authStatusSource.next(false);
                }
                observer.error(error);
              });
            } catch {
              console.log('Error while http get');
              observer.error('Error while http get');
            }
          }
          break;
        case 'delete':
          {
            try {
              const httpOptions = {
                headers: new HttpHeaders({
                  'Content-Type':  'application/json',
                  Authorization: 'Bearer ' + this.bearer
                }),
                withCredentials: true
              };
              this.http.delete(urltocall, httpOptions).subscribe(results => {
                try {
                  if (resultkey.length !== 0) {
                    if (typeof results[resultkey] === 'undefined') {
                      // No result key found
                      console.log('No result key found ', results);
                      observer.error('No result key found');
                    } else {
                      results = results[resultkey];
                    }
                  }
                  if (isItem) {
                    if (results instanceof Array) {
                      const buildItems = this.factory.itemsFromJson(results);
                      if (buildItems === null || buildItems.length === 0) {
                        observer.next(results);
                      } else {
                        observer.next(buildItems);
                      }
                    } else {
                      const buildItem = this.factory.itemFromJson(results);
                      if (buildItem === null) {
                        observer.next(results);
                      } else {
                        observer.next(buildItem);
                      }
                    }
                  } else {
                    observer.next(results);
                  }
                } catch (exception) {
                  // Just return json
                  console.log('Exception ' + exception.message + ' during call to ', urltocall);
                  observer.error('Exception during call to');
                }
              }, error => {
                if (error.status === 403) {
                  // Forbidden access
                  localStorage.removeItem('becare-logged-remote_addr');
                  localStorage.removeItem('becare-logged-userid');
                  localStorage.removeItem('becare-logged-bearer');
                  this.authenticated = false;
                  this.authStatusSource.next(false);
                }
                observer.error(error);
              });
            } catch {
              console.log('Error while http get');
              observer.error('Error while http get');
            }
          }
          break;
        }
    });
  }
}
